module.exports = __webpack_public_path__ + "static/img/floor2-xsbgt.ebb0680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-xsbgt.png
// module id = y2hx
// module chunks = 1